import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import Box from '@mui/material/Box';

const PatientManagementIcon: React.FC<SvgIconProps> = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 28,
        height: 28,
        borderRadius: '6px',
        bgcolor: '#F7F7FA',
      }}
    >
      <SvgIcon
        width="24"
        height="24"
        viewBox="2 2 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM9.74023 6.30957C8.69023 8.86957 6.6 10.8804 4 11.8604C4.00986 11.9003 4 11.9501 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 11.22 19.8799 10.4698 19.6699 9.75977C18.9699 9.90976 18.25 10 17.5 10C14.37 10 11.5802 8.55957 9.74023 6.30957ZM9 11.75C9.69 11.75 10.25 12.31 10.25 13C10.25 13.69 9.69 14.25 9 14.25C8.31 14.25 7.75 13.69 7.75 13C7.75 12.31 8.31 11.75 9 11.75ZM15 11.75C15.69 11.75 16.25 12.31 16.25 13C16.25 13.69 15.69 14.25 15 14.25C14.31 14.25 13.75 13.69 13.75 13C13.75 12.31 14.31 11.75 15 11.75ZM8.08008 5.03027C6.37017 6.00024 5.04994 7.57985 4.41992 9.46973C6.12983 8.49976 7.45006 6.92015 8.08008 5.03027ZM12 4C11.54 4 11.0901 4.05013 10.6602 4.12012C12.0602 6.44003 14.6001 8 17.5 8C17.96 8 18.4099 7.94987 18.8398 7.87988C17.4398 5.55997 14.8999 4 12 4Z"
          fill="#13A9BA"
        />
      </SvgIcon>
    </Box>
  );
};

export default PatientManagementIcon;
